<template>
  <hero-form />
</template>

<script>
import HeroForm from '../../components/heros/Form.vue'

export default {
  components: { HeroForm },
}
</script>

<style>

</style>
